


















import { Emit, Watch, Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class WxConfirm extends Vue {
    @Prop() private message!: string;
    @Prop() private title!: string;
    @Prop() private params!: object;
    @Prop() private value!: boolean;

    private options = {
        color: 'primary',
        width: 500,
        buttonTrueText: 'Ja',
        buttonFalseText: 'Nein',
    };

    private created() {
        Object.assign(this.options, this.params);
    }

    private get show() {
        return this.value;
    }

    private set show(value: boolean) {
        this.$emit('input', value);
    }

    private hndlCancel() {
        this.show = false;
    }

    private hndlAgree() {
        this.show = true;
    }
}
